import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import ga from '../../../utils/gaConnect';
import { noTextSelect } from '../../common/CssCommon';
import Dialog from '../Dialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../store/modules/dialog';
import ActiveLinkDialogFooter from './ActiveLinkDialogFooter';

import IconLink from '../../../img/activeLink/ribbonIcon/ribbon_big_ico_external_service.png';
import { usePOWebofficeSDKState } from '../../../context/poWebOfficeSDKContext';
import TextInput from '../../common/TextInput';
import { useCallback, useState } from 'react';
import { insertActiveLink } from '../../plugin/activeLink';
import { URLS } from '../../../define/global';
import { useWhiteListSliceSelector } from '../../../store/modules/whiteList';
import { getActiveLinkType } from '../../../utils/util';
import { ACTIVELINK_TYPE } from '../../../define/activeLinkDefine';

const DialogBody = styled.div`
  display: flex;
  flex-flow: column;
  align-items: flex-end;
  width: 568px;
  padding: 16px 16px 0px 16px;
  ${noTextSelect}
`;

const InputArea = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  flex-flow: row;

  padding: 0px 4px;
`;

const InputStringWrapper = styled.div`
  width: 80px;
  display: flex;
  justify-content: center;
  align-items: center;

  font-size: 14px;
  font-weight: 400;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2f3133;
`;

const TextInputWrapper = styled.div`
  flex: 1;
  margin-left: 17px;
`;

const SubTextArea = styled.div`
  width: 470px;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;

  padding: 5px 4px 0px;
`;

const Warning = styled.div`
  flex: 1;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #f33;
`;

const Guide = styled.a`
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: right;
  color: #1d7ff9;
`;

const FooterWrapper = styled.div`
  padding: 18px 20px;
`;

export default function ActiveLinkAnything({ isShow }) {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const poSDKContextState = usePOWebofficeSDKState();
  const { whitelist } = useWhiteListSliceSelector();

  const [url, setUrl] = useState('');
  const [warning, setWarning] = useState(null);

  const onDialogClose = useCallback(() => dispatch(closeDialog()), [dispatch]);

  const onInsertActiveLink = useCallback(
    async (url) => {
      try {
        ga.event({
          category: '액티브링크',
          action: '콘텐츠추가',
          label: '외부서비스'
        });
        const urlObj = new URL(url);
        const _url = `${urlObj.host.replace('www.', '')}${urlObj.pathname}`;
        if (_url.includes('youtube.com') || _url.includes('youtu.be')) {
          setWarning(t('ActiveLink.UseYoutubeLink'));
        } else {
          const activelinkType = getActiveLinkType(whitelist, url);
          switch (activelinkType) {
            case ACTIVELINK_TYPE.CANVAS: {
              setWarning(t('ActiveLink.UseCanvasLink'));
              break;
            }
            case ACTIVELINK_TYPE.NONE: {
              setWarning(t('ActiveLink.InvalidExternalService'));
              break;
            }

            case ACTIVELINK_TYPE.ACTIVELINK:
            default: {
              try {
                await insertActiveLink(poSDKContextState, url);
                onDialogClose();
              } catch (error) {
                ga.event({
                  category: '액티브링크',
                  action: '추가실패',
                  label: '외부서비스'
                });
              }
            }
          }
        }
      } catch (err) {
        setWarning(t('ActiveLink.InvalidServiceUrl'));
      }
    },
    [onDialogClose, poSDKContextState, t, whitelist]
  );

  return (
    <Dialog
      icon={IconLink}
      icon2x={IconLink}
      title={t('ActiveLink.ExternalService')}
      showTitleSeperateLine={true}
      showCloseBtn
      onClickCloseBtn={onDialogClose}
      isShow={isShow}>
      <DialogBody>
        <InputArea>
          <InputStringWrapper>URL</InputStringWrapper>
          <TextInputWrapper>
            <TextInput
              value={url}
              placeholder={t('ActiveLink.InputUrl')}
              onChange={(e) => setUrl(e.target.value)}
              onSubmit={onInsertActiveLink}></TextInput>
          </TextInputWrapper>
        </InputArea>
        <SubTextArea>
          {warning && <Warning>{warning}</Warning>}
          <Guide
            href={URLS.NOTION.ACTIVELINK_INSERT_EXTERNAL_GUIDE}
            target="_blank"
            onClick={() => {
              ga.event({ category: '액티브링크', action: '가이드보기', label: '외부서비스' });
            }}>
            {t('ActiveLink.DirectGuide')}
          </Guide>
        </SubTextArea>
      </DialogBody>
      <FooterWrapper>
        <ActiveLinkDialogFooter onSubmit={() => onInsertActiveLink(url)}></ActiveLinkDialogFooter>
      </FooterWrapper>
    </Dialog>
  );
}
